import InputInterface from "./InputInterface.ts";
import FormulaInterface from "./FormulaInterface.ts";

export default class ScalarInput implements InputInterface {
    value: any;

    /**
     * @param value
     */
    constructor(value: any) {
        this.value = value;
    }

    getName(): string {
        throw Error();
    }

    getReturnType(): string {
        throw Error();
    }

    getFormula(): FormulaInterface {
        throw Error();
    }

    /**
     * @param index
     * @param input
     */
    addInput(index: number, input: InputInterface): InputInterface {
        throw Error();
    }

    /**
     * @param index
     */
    getInput(index: number): InputInterface {
        throw Error();
    }

    /**
     * @param index
     */
    hasInput(index: number): boolean {
        throw Error();
    }

    /**
     * @param key
     */
    removeInput(key: number): void {
        throw Error();
    }

    serialize(): string {
        return this.value;
    }

    /**
     * @param value
     */
    setValue(value: any): void {
        this.value = value;
    }

    getValue(): any {
        return this.value;
    }

    /**
     * @param value
     */
    addValue(value: any): any {
        throw Error();
    }

    getAll(): Array<any> {
        throw Error();
    }

    /**
     * @param index
     */
    hasValue(index): boolean {
        throw Error();
    }

}


// WEBPACK FOOTER //
// ./src/Models/pricingRulesInterface/ScalarInput.ts